import { useQuery } from "@tanstack/react-query";
import { SessionService } from "@/services/brain/SessionService";

export const useSessionDetail = (sessionId: string | null, userId: string) => {
  return useQuery({
    queryKey: ["brain", "session-detail", sessionId, userId],
    queryFn: () => SessionService.getSessionDetail(sessionId as string, userId),
    enabled: !!sessionId && !!userId,
    staleTime: 30 * 1000,
  });
};
